<template>
  <div style="margin-top: -10px;">
    <el-tabs v-model="activeName" class="tabs">
      <el-tab-pane label="待处理" name="todo">
        <CheckOutlayTable :active="activeName"></CheckOutlayTable>
      </el-tab-pane>
      <el-tab-pane label="被退回" name="rollback">
        <CheckOutlayTable :active="activeName"></CheckOutlayTable>
      </el-tab-pane>
      <el-tab-pane label="超期未填写" name="timeout">
        <CheckOutlayTable :active="activeName"></CheckOutlayTable>
      </el-tab-pane>
      <el-tab-pane label="已处理" name="done">
        <CheckOutlayTable :active="activeName"></CheckOutlayTable>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import CheckOutlayTable from "./CheckOutlayTable";
export default {
  components: {
    CheckOutlayTable
  },
  data() {
    return {
      activeName: 'todo'
    };
  },
  watch: {
    '$route.query.tap': {
      handler () {
        this.activeName = this.$route.query.tap
      }
    }
  },
  created() {
    if(this.$route.query.tap){
      this.activeName = this.$route.query.tap
    }

  }
};
</script>

<style lang="scss" scoped>
@import "src/common/common";
</style>



// WEBPACK FOOTER //
// src/pages/outlay/check/CheckOutlayPage.vue